/* @jsx h */
import { defineComponent, h } from "vue";
//import { useAuth } from "../../providers/AuthProviders";
export const Loading = defineComponent({
  name: "Loading",
  setup() {
    return () => (
      <div class="flex justify-center items-center flex-col gap-3">
        <progress style="height: 2px;" class="progress w-56"></progress>
      </div>
    );
  },
});
